export default __webpack_public_path__ + "static/media/YAS0230.34I-29712_-17171_0.a48cfa05.jpg";